<div *ngIf="columns.length === 0" class="kanban-empty text-secondary">{{ emptyMessage }}</div>
<div
  class="business-document-kanban"
  [class.d-none]="columns.length === 0"
  [style.--kanban-viewport-offset]="viewportOffset">
  <div #kanbanCanvas class="kanban-tree-canvas" [style.min-width]="canvasMinWidth">
    <svg
      *ngIf="connectors.length"
      class="kanban-connectors"
      aria-hidden="true"
      [attr.width]="connectorWidth"
      [attr.height]="connectorHeight"
      [attr.viewBox]="'0 0 ' + connectorWidth + ' ' + connectorHeight">
      <path
        *ngFor="let connector of connectors; trackBy: trackConnector"
        [attr.d]="connector.path"
        [class.is-default]="connector.isDefault"></path>
    </svg>

    <div class="kanban-levels">
      <div
        *ngFor="let level of levels; trackBy: trackLevel"
        class="kanban-level"
        [class.is-terminal-level]="level.terminal">
        <section
          #stageBoard
          *ngFor="let column of level.columns; trackBy: trackColumn"
          class="kanban-board"
          [attr.data-column-id]="column.id"
          [ngClass]="accentClass(column)">
          <header class="kanban-board-header">
            <span>{{ column.title }}</span>
            <span *ngIf="column.summary" class="kanban-column-summary">{{ column.summary }}</span>
          </header>
          <div #columnList class="kanban-drag" [attr.data-column-id]="column.id">
            <button
              *ngFor="let card of column.cards; trackBy: trackCard"
              type="button"
              class="kanban-item"
              [class.is-disabled]="card.disabled"
              [attr.data-card-id]="card.id"
              (click)="openCard(card)">
              <ng-container *ngIf="cardComponent; else missingCard">
                <ng-container *ngComponentOutlet="cardComponent; inputs: cardInputs(card)"></ng-container>
              </ng-container>
              <ng-template #missingCard><span class="text-danger small">Document card is not configured.</span></ng-template>
            </button>
            <div *ngIf="column.cards.length === 0" class="kanban-column-empty">
              {{ draggable ? 'Drop an allowed record here' : 'No records' }}
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
